import produce from 'immer'

import { FETCH_STATUSES, FETCH_STATUSES_SUCCESS, FETCH_STATUSES_FAILURE } from '../actions/types'

export const initialStatusState = {
  client: '',
  id: '',
  isSuccessful: false,
  status: '',
  url: '',
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_STATUSES: {
      draft.fetching = true
      break
    }
    case FETCH_STATUSES_SUCCESS: {
      const statuses = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Add all statuses to state
      for (const status of statuses) {
        const id = status.client
        if (draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...initialStatusState,
          ...status,
          id,
        }
      }

      break
    }
    case FETCH_STATUSES_FAILURE: {
      const error = payload

      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
